module.exports = __webpack_public_path__ + "static/media/croissant.365402cd.svg";